<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto text-center" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>شماره کارت بانک ملت   </template>
                </m-p><m-copy-1 v-bind='{...{"itemId":6104338931499707,"itemType":"text","iconName":"files"},...{}}' :style='"direction:ltr;\n"' class="my-2" >
                <template #default>6104 3389 3149 9707
:رضوان فرهمند   </template>
                </m-copy-1><m-copy-1 v-bind='{...{"itemId":"IR730120020000009574840722","itemType":"text","iconName":"files"},...{}}' :style='"direction:ltr;\n"' class="my-2" >
                <template #default>IR730120020000009574840722   </template>
                </m-copy-1><m-hr v-bind='{...{},...{}}' :style='""' class="" ></m-hr></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto text-center" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>شماره کارت بانک سپه   </template>
                </m-p><m-copy-1 v-bind='{...{"itemId":5892101240736062,"itemType":"text","iconName":"files"},...{}}' :style='"direction:ltr;\n"' class="my-2" >
                <template #default>5892 1012 4073 6062
:رضوان فرهمند راد
   </template>
                </m-copy-1><m-copy-1 v-bind='{...{"itemId":"IR070150000000437301653412","itemType":"text","iconName":"files"},...{}}' :style='"direction:ltr;\n"' class="my-2" >
                <template #default>IR070150000000437301653412   </template>
                </m-copy-1><m-hr v-bind='{...{},...{}}' :style='""' class="" ></m-hr></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto text-center" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="bg-primary py-2 rounded" >
                <template #default>لطفا قبل از واریز تماس بگیرید   </template>
                </m-h5><m-div v-bind='{...{},...{}}' :style='""' class="mb-5" >
                <template #default>تماس با ما   <m-a v-bind='{...{"href":"mailto:info@khorakdamiran.com","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2" >
                <template #default>info@khorakdamiran.com   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+986142544241","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2  btn btn-primary" >
                <template #default>06142544241   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+989166404026","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2  btn btn-primary" >
                <template #default>09166404026   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+989166469640","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2 btn btn-primary" >
                <template #default>مدیر فروش قارچ و کمپوست قارچ
09166469640   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+989190102898","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2 btn btn-primary" >
                <template #default>شماره تماس صادرات
09190102898   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mCopy1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Copy/Copy1'; import mHr from '@moeinmdn/miw-alpha-components/src/package/Tags/Hr'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mP,mCopy1,mHr,mH5,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
